export default "__VITE_ASSET__DdmfVGLq__"